/** 실제 지점 사진이 없는 경우에만 사용하는 공통 일러스트. */
export const DEFAULT_BRANCH_IMAGE = "/images/placeholders/branch-default.webp";
